/**
 * Document view component.
 * @module components/theme/View/ListingView
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Container } from 'semantic-ui-react';
import ArticleIcon from '../../../../components/Blog/ArticleIcon';
import TagLinks from '../../../../components/Blog/TagLinks';
import {
  formatDate,
  isPublishedNow,
  itemDate,
  itemTags,
  itemUrl,
} from '../../../../components/Blog/utils';

/**
 * List view component class.
 * @function ListingView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const ListingView = ({ content }) => (
  <Container id="page-home">
    <section id="content-core" className="ehon-card-grid">
      {content.items.filter(isPublishedNow).map((item, index) => (
        <Segment
          key={item.url}
          className={`listing-item ehon-card ${
            index === 0 ? 'ehon-card-featured' : ''
          }`}
        >
          <Container className="ehon-card-body">
            <ArticleIcon item={item} />
            <span className="ehon-card-date">
              {formatDate(itemDate(item)) || '読書記録'}
            </span>
            <h2>
              <a href={itemUrl(item)} title={item['@type']}>
                {item.title}
              </a>
            </h2>
            <TagLinks tags={itemTags(item)} compact />
            {item.description && <p>{item.description}</p>}
          </Container>
        </Segment>
      ))}
    </section>
  </Container>
);

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
ListingView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        '@id': PropTypes.string,
        '@type': PropTypes.string,
        description: PropTypes.string,
        review_state: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string,
        created: PropTypes.string,
        Subject: PropTypes.arrayOf(PropTypes.string),
      }),
    ),
  }).isRequired,
};

export default ListingView;
